export default __webpack_public_path__ + "static/media/move_backwards.65f44df7.mp3";